import React from "react"
const SeccionFiltros = (props) => {
    return (
        <div className={`p-col-12 ${props.extra || ""}`} style={props.style}>
            <div className={`p-grid filtros ${props.extra ? props.extra : ""}`} >
                {props.children}
            </div>
        </div>)
}
export default SeccionFiltros;